import React, { Component } from 'react';
import { Modal, Form, Input, Select, Button, Tag } from 'antd';
import { useGetCompanyListMinimal } from '../../hooks/useCompanies';
import stc from 'string-to-color';

export default function InviteUser({ open, onCancel, onOk }) {
    const { data: companyCodeList } = useGetCompanyListMinimal();

    return (
        <>
            <Modal open={open} onCancel={onCancel} footer={null}>
                <div>
                    <Form onFinish={onOk}>
                        <Form.Item
                            label="Select Companies"
                            name="companyCodes"
                            rules={[
                                {
                                    type: 'array',
                                    min: 1,
                                },
                            ]}
                        >
                            <Select
                                mode="multiple"
                                options={companyCodeList?.map(company => {
                                    return {
                                        label: <Tag color={stc(company?.code)}>{company?.code}</Tag>,
                                        value: company?.code,
                                    };
                                })}
                                showSearch
                                allowClear
                                maxTagCount={1}
                                optionFilterProp="value"
                            />
                        </Form.Item>
                        <Form.Item
                            label="User Email"
                            name="email"
                            rules={[
                                {
                                    type: 'email',
                                    required: true,
                                    message: 'Please Enter a valid email',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <Button block type="primary" htmlType="submit" hidden={true}>
                                Invite user
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
}
